import { Box, Button, getColor, Typography } from "fds";
import "../index.scss";
import { t } from "i18next";
const ClientNone = () => {
  const handleGoWeb = () => {
    const agent = navigator.userAgent.toLowerCase();

    if (agent.indexOf("macintosh") > -1) {
      if (
        agent.toLowerCase().indexOf("safari") === -1 &&
        (window as any)?.webkit?.messageHandlers
      ) {
        (window as any)?.webkit?.messageHandlers.goWebWorkgroup.postMessage("");
      }
    } else {
      if (window?.chrome?.webview && window?.chrome?.webview?.hostObjects) {
        window?.chrome?.webview?.hostObjects.client.goWebWorkgroup("");
      }
    }
  };
  return (
    <Box
      width={"100%"}
      direction="column"
      justifyContent="center"
      alignItems="center"
      height={"100%"}
    >
      <img
        src={require("../../../shared/images/pages/Workgroup/emptyWorkgroup.png")}
        alt="noFilter"
        width={200}
      />
      <Typography type="h3" classes="mg mt-40">
        {t("login.uidLink.startEco")}
      </Typography>
      <Typography
        type="body4_rg"
        exactColor={getColor("COLOR_TEXT_SECONDARY")}
        classes="mg mt-2"
      >
        {t("login.uidLink.chooseMethod")}
      </Typography>
      <Button
        label={t("login.uidLink.goWeb")}
        btnStyle="fill"
        width="fit-content"
        classes="mg mt-20"
        onClick={handleGoWeb}
      />
    </Box>
  );
};

export default ClientNone;
